module.exports = __webpack_public_path__ + "static/media/flag_om.81321193.png";